"use strict";

const ManholeInventoryData = function () {
  var getProps = function () {
    return {
      manholeTypeOptions: ToolSettings.getDomainOptions("manhole_type"),
      coverTypeOptions: ToolSettings.getDomainOptions("manhole_cover_type"),
      coverShapeOptions: ToolSettings.getDomainOptions("manhole_cover_shape"),
      coneTypeOptions: ToolSettings.getDomainOptions("manhole_cone_type"),
      materialOptions: ToolSettings.getDomainOptions("material"),
      datumOptions: ToolSettings.getDomainOptions("datum"),
      lengthUnitOptions: OutfallInspectionConstants.lengthUnitOptions,
      elevationUnitOptions: OutfallInspectionConstants.elevationUnitOptions,
    };
  };

  return {
    getProps,
  };
};

module.exports = ManholeInventoryData();

const OutfallInspectionConstants = require("../../../outfalls/outfallInspectionConstants");
const ToolSettings = require("../../../settings/toolSettings");
